module.exports = __webpack_public_path__ + "img/metal-roof.0e642da8.jpg";